// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2rA79","header":"MergedInvoice_header__1h5az"};